function DownCaretIcon() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='10' height='6' fill='none' viewBox='0 0 10 6'>
      <path
        fill='#465364'
        d='M5 5.984a.48.48 0 01-.343-.142L.142 1.326A.484.484 0 11.826.642L5 4.816 9.174.642a.484.484 0 11.684.684L5.343 5.842a.485.485 0 01-.344.142z'
      />
    </svg>
  );
}

export default DownCaretIcon;
